import React from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { Card } from '@winnin/winnin_ui.components.card'
import { Loading } from '@winnin/winnin_ui.components.loading'
import { Title } from '@winnin/winnin_ui.components.title'

import BlockComponents from 'components/BlockComponents'
import QuestionMarkTooltip from 'components/QuestionMarkTooltip'
import { T, useTranslate } from 'lib/tolgee'
import { UserStore } from 'stores'

import EmptyState from '../EmptyState'
import VideosGrid from '../VideosGrid'
import './index.scss'

function VideosCard({
  seeMore,
  videos,
  loading,
  title,
  subtitle,
  actions,
  header,
  tooltipContent,
  seeMoreAsCard,
  onSeeMoreCard,
}) {
  const t = useTranslate()
  const hasVideos = videos.length > 0
  const seeMoreAction = hasVideos ? seeMore : null
  const wrapperClasses = classNames('videos-card-container', 'title-actions-content', {
    'with-actions-secondary': !!seeMoreAction,
  })

  const isUserViewer = UserStore.getRole === 'viewer'

  return (
    <div className={wrapperClasses}>
      {title && (
        <div className="title">
          <div className="title-container">
            <Title tag="h3">{title}</Title>
            {tooltipContent && <QuestionMarkTooltip title={tooltipContent} />}
          </div>
          {subtitle && (
            <Title weight="regular" className="subtitle" tag="h6">
              {subtitle}
            </Title>
          )}
        </div>
      )}
      {header && <>{header}</>}

      {loading && <Loading className="content" />}

      {actions && <div className="actions">{actions}</div>}

      {!loading && hasVideos && (
        <VideosGrid
          loadMore={() => {}}
          gridWrapperClass="card-videos-grid content"
          videos={videos}
          seeMoreAsCard={seeMoreAsCard}
          onSeeMoreCard={onSeeMoreCard}
          hideListView
        />
      )}

      {seeMoreAction && !seeMoreAsCard && (
        <div className="actions-secondary actions-box">
          <div className="actions-right">
            <BlockComponents tooltipPositionClassname="tooltipped-n" isClickBlocked={isUserViewer}>
              <Link to={seeMoreAction}>
                <T keyName="VideosCard-seeMoreButton">See more</T>
              </Link>
            </BlockComponents>
          </div>
        </div>
      )}

      {!loading && !hasVideos && (
        <Card className="content">
          <EmptyState
            headerText={t({
              defaultValue: 'No Videos to show',
              key: 'VideosCard-emptyHeader',
            })}
            text={t({
              defaultValue: 'There were no videos published on this date range',
              key: 'VideosCard-emptyText',
            })}
          />
        </Card>
      )}
    </div>
  )
}

VideosCard.propTypes = {}

VideosCard.defaultProps = {
  hideSelect: false,
  filterGroupName: 'videos',
  title: '',
  header: '',
}

VideosCard.displayName = 'VideosCard'

export default observer(VideosCard)
